module.exports = __webpack_public_path__ + "static/media/natura-startups.308feea4.png";